import { useState, useEffect } from 'react';
import { Heart } from 'lucide-react';
import { useLocation } from 'react-router-dom';
import axios from 'axios';
import DonationModal from './DonationModal';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

export default function DonationButton() {
  const [isVisible, setIsVisible] = useState(true);
  const [isEnabled, setIsEnabled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Fetch donation button settings
    const fetchSettings = async () => {
      try {
        const response = await axios.get(`${API}/settings/coffee-link`);
        setIsEnabled(response.data.enabled !== false);
      } catch (error) {
        console.error('Failed to load donation settings:', error);
      }
    };
    fetchSettings();
  }, []);

  // Fade out after 3 seconds and stay out until page changes
  useEffect(() => {
    setIsVisible(true);
    const timer = setTimeout(() => {
      setIsVisible(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [location.pathname]);

  // Don't render if disabled
  if (!isEnabled) {
    return null;
  }

  return (
    <>
      <button
        onClick={() => setShowModal(true)}
        className={`fixed right-6 bottom-32 z-50 px-6 py-3 rounded-full shadow-lg transition-all duration-500 flex items-center gap-2 ${
          isVisible ? 'opacity-100 translate-y-0' : 'opacity-0 translate-y-4 pointer-events-none'
        }`}
        style={{
          background: 'linear-gradient(135deg, #E8934D 0%, #E85D4D 100%)',
          border: '3px solid #2C1810',
        }}
        title="Buy me a Coffee"
        data-testid="coffee-button"
      >
        <Heart className="w-6 h-6 text-white" fill="white" />
        <span className="text-white font-bold text-sm hidden sm:inline">Buy me a Coffee!</span>
      </button>

      <DonationModal isOpen={showModal} onClose={() => setShowModal(false)} />
    </>
  );
}
